<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    :title="title"
    :visible.sync="dialogFormVisible"
    @closed="closed"
    :modal="false"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="复核状态"
        :label-width="formLabelWidth"
        prop="reviewStatus"
      >
        <el-select
          class="search-select"
          v-model="editForm.reviewStatus"
          clearable
          placeholder="请选择复核状态"
        >
          <el-option
            v-for="item in checkStatusList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="复核备注"
        :label-width="formLabelWidth"
        prop="reviewOpinion"
      >
        <el-input
          v-model="editForm.reviewOpinion"
          type="textarea"
          autocomplete="off"
          placeholder="请输入复核备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button style="margin: 0 10px 0" type="primary" @click="submitEdit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { updateReviewStatusApi } from '@/api/notice';
export default {
  data() {
    return {
      title: '',
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      // 编辑表单
      editForm: {
        houseRateId: null,
        reviewStatus: '',
        reviewOpinion: '',
      },
      checkStatusList: [
        // {
        //   label: '未复核',
        //   id: 0,
        // },
        {
          label: '已复核',
          id: 1,
        },
        {
          label: '驳回',
          id: 2,
        },
      ],
      // 表单的验证规则
      editRules: {
        reviewStatus: [
          { required: true, message: '请选择复核状态！', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    // console.log('form', this.editForm);
  },
  methods: {
    // 提交按钮
    submitEdit() {
      try {
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return;
          try {
            let res = await updateReviewStatusApi({
              ...this.editForm,
            });
            if (res.code == 200) {
              this.$message.success('操作成功');
              this.dialogFormVisible = false;
              this.resetForm();
              this.$emit('reload');
            } else {
              // this.$message.warning('操作失败');
            }
          } catch (error) {
            this.$message.warning('操作失败');
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 关闭时的回调
    closed() {
      this.dialogFormVisible = false;
      this.resetForm();
    },

    // 清空表单
    resetForm() {
      this.editForm = {
        houseRateId: null,
        reviewStatus: '',
        reviewOpinion: '',
      };
      this.$refs['editForm'].resetFields();
    },
  },
};
</script>
